import React from "react";
import { StepShell } from "@/components/StepShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n } from "@/i18n";
import { User } from "lucide-react";

const Field = ({ label, required, children }) => (
  <div className="space-y-1.5">
    <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
      {label} {required && <span className="text-destructive">*</span>}
    </Label>
    {children}
  </div>
);

export const IntakeForm = ({ data, update }) => {
  const { t, tc } = useI18n();
  const p = data.patient;
  const set = (patch) => update("patient", patch);

  return (
    <StepShell icon={User} title={t("if_title")} subtitle={t("if_sub")} testId="intake-step">
      <div className="rounded-xl border border-slate-200 bg-white p-6 sm:p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Field label={t("if_cognome")} required>
            <Input data-testid="patient-cognome-input" value={p.cognome}
              onChange={(e) => set({ cognome: e.target.value })} placeholder={t("if_cognome_ph")} />
          </Field>
          <Field label={t("if_nome")} required>
            <Input data-testid="patient-nome-input" value={p.nome}
              onChange={(e) => set({ nome: e.target.value })} placeholder={t("if_nome_ph")} />
          </Field>
          <Field label={t("if_nascita")}>
            <Input type="date" data-testid="patient-nascita-input" value={p.dataNascita}
              onChange={(e) => set({ dataNascita: e.target.value })} />
          </Field>
          <Field label={t("if_genere")}>
            <Select value={p.genere} onValueChange={(v) => set({ genere: v })}>
              <SelectTrigger data-testid="patient-genere-select"><SelectValue placeholder={t("select_ph")} /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Femmina">{tc("Femmina")}</SelectItem>
                <SelectItem value="Maschio">{tc("Maschio")}</SelectItem>
                <SelectItem value="Altro / n.d.">{tc("Altro / n.d.")}</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <Field label={t("if_mansione")}>
            <Input data-testid="patient-mansione-input" value={p.mansione}
              onChange={(e) => set({ mansione: e.target.value })} placeholder={t("if_mansione_ph")} />
          </Field>
          <Field label={t("if_azienda")}>
            <Input data-testid="patient-reparto-input" value={p.reparto}
              onChange={(e) => set({ reparto: e.target.value })} placeholder={t("if_azienda_ph")} />
          </Field>
          <Field label={t("if_correzione")}>
            <Select value={p.correzione} onValueChange={(v) => set({ correzione: v })}>
              <SelectTrigger data-testid="patient-correzione-select"><SelectValue placeholder={t("select_ph")} /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Nessuna">{tc("Nessuna")}</SelectItem>
                <SelectItem value="Occhiali">{tc("Occhiali")}</SelectItem>
                <SelectItem value="Lenti a contatto">{tc("Lenti a contatto")}</SelectItem>
                <SelectItem value="Occhiali per VDT">{tc("Occhiali per VDT")}</SelectItem>
              </SelectContent>
            </Select>
          </Field>
          <Field label={t("if_data_esame")}>
            <Input type="date" data-testid="patient-data-esame-input" value={p.dataEsame}
              onChange={(e) => set({ dataEsame: e.target.value })} />
          </Field>
          <div className="md:col-span-2">
            <Field label={t("if_medico")}>
              <Input data-testid="patient-medico-input" value={p.medico} readOnly disabled className="bg-slate-50 text-slate-600" />
              <p className="mt-1 text-xs text-slate-400">{t("if_medico_hint")}</p>
            </Field>
          </div>
        </div>
        <p className="mt-6 text-xs text-slate-400">{t("if_footer")}</p>
      </div>
    </StepShell>
  );
};
